import { createRoot } from "react-dom/client";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById("root"));

async function bootstrap() {
  // Opt-in API mocking for local development:
  //   REACT_APP_USE_MOCKS=true yarn start
  if (
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_USE_MOCKS === "true"
  ) {
    const { worker } = require("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  }
  root.render(<App />);
}

bootstrap();

reportWebVitals();
